<template>
    <div class="content" v-loading="comprehensive">
        <el-row :span="24">
            <el-form :model="addForm" label-position="right" label-width="145px" class="boxMong" ref="addForm" status-icon>
                <el-row :span="24" class="isolation" style="padding-bottom: 0px;">
                    <el-col :span="24" style="text-align:left;padding-left:12px;font-size:15px;ont-weight: bold;">
                        <p class="pparScore">
                            <span style="font-size:40px;line-height: 36px;">{{addForm.zooScore||0}}分</span></br>
                            <span>考试得分</span>
                        </p>
                        <p class="peparName">试卷名称：<b>{{addForm.name}}</b></p>
                        <p class="peparInfo">
                            <span>考生姓名：{{addForm.userName}}</span>
                            <span>测评时间：{{addForm.startTime}}</span>
                            <span>考试用时：{{addForm.yongshi}}</span>
                        </p>
                    </el-col>
                </el-row>
            
                <!-- 组列表 > 题目列表 -->
                <p class="titleMsg">{{addForm.name}} - 试卷分析</p>
                <el-row :span="24" class="addListTitle">
                    <group-title ref="groupTitle"></group-title>
                </el-row>

                <el-row :span="24" :class="['pepsi',{'flexBottom':hJump}]">
                    <el-button size="mini" class="closePepsi" type="success" @click.native="goPageList"> 返回首页 </el-button>
                </el-row>
            </el-form>
        </el-row>
    </div>
</template>
<script>
import groupTitle from './groupTitle'
import util from '../../lib/util'
    export default {
        data() {
            return {
                comprehensive:false,
                addForm:{
                    name:'',
                    zooScore:0,
                    userName:'',
                    startTime:'',
                    yongshi:'',
                },
                usermsg:this.$base64.decode(window.localStorage.getItem('usermag-web')),
                uid:this.$base64.decode(window.localStorage.getItem('uid-web')),
                _gap_time:'',
                _beforeUnload_time:'',
                hJump:false,
            }
        },
        components:{
            groupTitle
        },
        watch: {
        },
        destroyed() {
            window.removeEventListener('beforeunload', e => this.beforeunloadHandler(e))
            window.removeEventListener('unload', e => this.unloadHandler(e))
        },
        computed:{
        },
        created(){
        },
        mounted(){
            this.$nextTick(()=>{
                this.getData()

                // 在每个页面加载完成时执行以下代码
                window.history.pushState(null, null, window.location.href);
            })
            // 退出浏览器删除缓存
            window.addEventListener('beforeunload', e => this.beforeunloadHandler(e))
            window.addEventListener('unload', e => this.unloadHandler(e))

            // 禁止后退
            window.history.pushState(null, null, window.location.href);
            window.addEventListener('popstate', function () {
                window.history.forward(-1);
                window.history.pushState(null, null, window.location.href);
            });
        },
        methods: {
            //编辑
            getData(id){
                let paperId = this.$route.query.id
                let locp = JSON.parse(localStorage.getItem('ceping-'+this.uid+'-'+paperId))
                this.obtainInfo(paperId,locp)
            },
            obtainInfo(id,locp){
                let that = this
                that.$axios.post('/paper/info',{
                    isFull:'1',
                    paperId:id,
                    uid:Number(that.$base64.decode(window.localStorage.getItem('uid-web')))
                }, res => {
                    let v = res.data.data;
                    that.addForm = v
                    that.addForm.userName = JSON.parse(that.usermsg).name
                    that.addForm.startTime = locp.startDateVal
                    let timeCha = Date.parse(new Date(that.$route.query.endDateVal))-Date.parse(new Date(locp.startDateVal))
                    // let timeCha = Number((v.examMin*60) - locp.time)*1000
                    that.addForm.yongshi = util.getRemainderTime(timeCha)
                    that.addForm.zooScore = 0
                    that.oneCase = true
                    let drr = util.deepClone2(v.groupList)
                    let obj = locp.dataList
                    for (let x = 0; x < drr.length; x++) {
                        let listArr = drr[x].questionList
                        for (let i = 0; i < listArr.length; i++) {
                            for (const key in obj) {
                                if (obj.hasOwnProperty(key)) {
                                    const ele = obj[key].obj;
                                    if(listArr[i].bId == ele.paperQuestionId){
                                        that.oneCase = false
                                        listArr[i].questionDto['bbId'] = listArr[i].bId
                                        if(listArr[i].questionDto.typeCode==60){
                                            if(ele.rhythmBeatVal){
                                                listArr[i].questionDto['case'] = true
                                            }else{
                                                listArr[i].questionDto['case'] = false
                                            }
                                        }else if(listArr[i].questionDto.typeCode==61){
                                            if(ele.rhythmSingAudioUrl){
                                                listArr[i].questionDto['case'] = true
                                            }else{
                                                listArr[i].questionDto['case'] = false
                                            }
                                        }else{
                                            listArr[i].questionDto['case'] = true
                                        }
                                        ele.score = ele.score? ele.score:0
                                        that.addForm.zooScore = util.unsingNumber((that.addForm.zooScore+ele.score),'floor',2)
                                        listArr[i].questionDto['userScore'] = util.unsingNumber(ele.score,'floor',2)
                                        listArr[i].questionDto['selectIds'] = ele.selectIds
                                        listArr[i].questionDto['singAudioUrl'] = ele.singAudioUrl
                                        listArr[i].questionDto['textVideoUrl'] = ele.textVideoUrl
                                        listArr[i].questionDto['writeImgUrl'] = ele.writeImgUrl
                                        listArr[i].questionDto['rhythmBeatVal'] = ele.rhythmBeatVal  //打谱题 打点数据
                                        listArr[i].questionDto['rhythmBeatAudioUrl'] = ele.rhythmBeatAudioUrl? ele.rhythmBeatAudioUrl:'1',  //打谱题合成的url
                                        listArr[i].questionDto['rhythmSingAudioUrl'] = ele.rhythmSingAudioUrl? ele.rhythmSingAudioUrl:'1',
                                        listArr[i].questionDto['fillBlankVal'] = ele.fillBlankVal
                                        listArr[i].questionDto['drawImgUrl'] = ele.drawImgUrl
                                        listArr[i].questionDto['detailJsonVal'] = ele.detailJsonVal
                                        break;
                                    }
                                }
                            }
                        }
                    }
                    that.$nextTick(()=>{
                        that.comprehensive = false
                        that.$refs.groupTitle.editData(drr)

                        setTimeout(()=>{
                            let ch = document.getElementsByClassName('content')[0].offsetHeight + 60
                            let lc = document.documentElement.clientHeight
                            if(ch<lc) that.hJump = true
                        },200)
                    })
                })
            },
            goPageList(){
                localStorage.getItem('ceping-'+this.uid+'-'+this.$route.query.id)? localStorage.removeItem('ceping-'+this.uid+'-'+this.$route.query.id):''
                if(sessionStorage.getItem('orgId')){//测评
                    this.$router.push({
                        path: `/${sessionStorage.getItem('orgId')}/examList`,
                    })
                }else{
                    this.$router.push({
                        path: '/myExamList'
                    })
                }
            },
            beforeunloadHandler(){
                this._beforeUnload_time=new Date().getTime();
            },
            unloadHandler(e){
                this._gap_time=new Date().getTime()-this._beforeUnload_time;
                //判断是窗口关闭还是刷新
                if(this._gap_time<=5){
                    localStorage.getItem('ceping-'+this.uid+'-'+this.$route.query.id)? localStorage.removeItem('ceping-'+this.uid+'-'+this.$route.query.id):''
                }
            },
        }
    }
</script>
<style scoped lang="less">
    .boxMong{
        box-sizing: border-box;
        margin-bottom: 10px;
    }
    .isolation{
        box-sizing: border-box;
        padding: 25px 30px;
        background: #004BB4;
        color: #fff;
        height: 100px;
        .peparName{
            width: 70%;
            float: left;
            font-size: 18px;
            font-weight: bold;
        }
        .peparInfo{
            width: 70%;
            float: left;
            span:nth-child(1){margin-left: 0;}
            span{
                margin-left: 15px;
            }
        }
        .pparScore{
            width: 25%;
            float:right;
            text-align: center;
        }
    }
    .isolation .el-form-item{
        margin:0;
    }
    .titleMsg{
        text-align: center;
        font-size: 23px;
        font-weight: bold;
        padding: 10px 0;
        margin-top: 12px;
    }
    .addListTitle{
        box-sizing: border-box;
        padding: 10px;
    }
    .pepsi{
        height: 60px;
        background: #F5F9FE;
        position: relative;
        .closePepsi{
            position: absolute;
            margin: auto;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            height: 32px;
            width: 180px;
            font-size: 14px;
        }
    }
    .flexBottom{
        position: fixed;
        bottom: 0;
        width: 1024px;
        left: 0;
        right: 0;
        margin: auto;
    }
</style>
<style>
    .boxMong .el-form-item__error{
        display: none;
    }
    .addListTitle .el-form-item__label{
        text-align: left !important;
    }
</style>


// WEBPACK FOOTER //
// src/pages/cpResults/resultsShow.vue